export const iconFontAwesomeHumanitarianHotel = (
	<i className="fa-solid fa-hotel"></i>
);
